import { render, staticRenderFns } from "./index-v2.vue?vue&type=template&id=9060b56e"
import script from "./index-v2.vue?vue&type=script&lang=js"
export * from "./index-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports